import { createContext, useContext } from "react";
import { IActionPlansEditionContext } from "./ActionPlansEditionContextInterface";

export const initialState: IActionPlansEditionContext = {
    edit: [],
    setEdit: () => {},
    isSavingInline: false,
    setIsSavingInline: () => {},
    handleStartInlineEdit: () => {},
    handleSaveInlineEdit: () => {},
    handleCancelInlineEdit: () => {},
};

export const ActionPlansEditionContext = createContext<IActionPlansEditionContext>(initialState);

export const useActionPlansEditionContext = () => useContext(ActionPlansEditionContext);
